import { render } from "./WorkUnit.vue?vue&type=template&id=38a6e31f&scoped=true"
import script from "./WorkUnit.vue?vue&type=script&lang=js"
export * from "./WorkUnit.vue?vue&type=script&lang=js"

import "./WorkUnit.vue?vue&type=style&index=0&id=38a6e31f&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a6e31f"]])

export default __exports__